import React, { useState, useEffect } from 'react'
import { ArrowPathIcon, XMarkIcon } from '@heroicons/react/24/outline'

function UpdateBanner() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const handler = () => setShow(true)
    window.addEventListener('swUpdateReady', handler)
    return () => window.removeEventListener('swUpdateReady', handler)
  }, [])

  if (!show) return null

  return (
    <div className="bg-blue-600 text-white px-4 py-2 text-sm font-medium flex items-center justify-center gap-2">
      <ArrowPathIcon className="w-4 h-4" />
      <span>A new version is available</span>
      <button
        onClick={() => {
          if (window.__swUpdateReady) window.__swUpdateReady(true)
          window.location.reload()
        }}
        className="ml-2 px-2 py-0.5 bg-white/20 hover:bg-white/30 rounded text-xs font-semibold transition-colors"
      >
        Update now
      </button>
      <button
        onClick={() => setShow(false)}
        className="ml-1 text-white/70 hover:text-white"
      >
        <XMarkIcon className="w-4 h-4" />
      </button>
    </div>
  )
}

export default UpdateBanner
